import { Card } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useTenant } from "../../../store/context/tenant-context";
import { useTheme } from "../../../store/context/theme-context";
import { useState } from "react";

const ChangeProfileCard = ({ iconOne, title, description, onCardClick }) => {
  const tenant = useTenant();
  const { theme } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  // Create gradient background for icon based on primary color
  const getIconGradient = () => {
    const primaryColor = tenant.theme.colorPrimary;
    // Create a lighter version for gradient
    return `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}25 100%)`;
  };

  return (
    <Card
      className="rounded-xl w-full h-full cursor-pointer transition-all duration-300 ease-in-out border-0"
      onClick={onCardClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        boxShadow: isHovered
          ? `0 12px 24px -10px ${tenant.theme.colorPrimary}40, 0 0 0 1px ${tenant.theme.colorPrimary}20`
          : theme === "dark"
          ? "0 2px 8px rgba(0, 0, 0, 0.45)"
          : "0 2px 8px rgba(0, 0, 0, 0.06)",
        transform: isHovered ? "translateY(-4px)" : "translateY(0)",
        backgroundColor: theme === "dark" ? "#1f1f1f" : "#ffffff",
        border: isHovered ? `1px solid ${tenant.theme.colorPrimary}30` : "1px solid transparent",
      }}
      bodyStyle={{ padding: "20px" }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-4 flex-1">
          {/* Enhanced Icon Container */}
          <div className="flex-shrink-0">
            <div
              className="rounded-xl p-4 transition-all duration-300"
              style={{
                background: isHovered
                  ? `linear-gradient(135deg, ${tenant.theme.colorPrimary}20 0%, ${tenant.theme.colorPrimary}35 100%)`
                  : getIconGradient(),
                transform: isHovered ? "scale(1.05)" : "scale(1)",
                boxShadow: isHovered
                  ? `0 4px 12px ${tenant.theme.colorPrimary}30`
                  : "none",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  color: tenant.theme.colorPrimary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {iconOne}
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="flex-1 pt-1">
            <h3
              className="font-semibold text-base mb-1 transition-colors duration-200"
              style={{
                color: theme === "dark" ? "#ffffff" : "#1f1f1f",
              }}
            >
              {title}
            </h3>
            <p
              className="text-sm leading-relaxed"
              style={{
                color: theme === "dark" ? "#8c8c8c" : "#666666",
              }}
            >
              {description}
            </p>
          </div>
        </div>

        {/* Arrow Icon */}
        <div
          className="flex-shrink-0 transition-all duration-300 mt-1"
          style={{
            transform: isHovered ? "translateX(4px)" : "translateX(0)",
            color: isHovered ? tenant.theme.colorPrimary : theme === "dark" ? "#8c8c8c" : "#bfbfbf",
          }}
        >
          <RightOutlined style={{ fontSize: "14px" }} />
        </div>
      </div>

      {/* Subtle bottom accent line on hover */}
      <div
        className="absolute bottom-0 left-0 right-0 h-1 rounded-b-xl transition-all duration-300"
        style={{
          background: `linear-gradient(90deg, ${tenant.theme.colorPrimary} 0%, ${tenant.theme.colorPrimary}80 100%)`,
          opacity: isHovered ? 1 : 0,
        }}
      />
    </Card>
  );
};

export default ChangeProfileCard;
